import moment from 'moment';
export var formatarData = function (valor) {
    if (!valor) {
        return '';
    }
    moment.locale('pt-br');
    return moment(valor).format('DD/MM/YYYY');
};
export var formatarDataHora = function (valor) {
    if (!valor) {
        return '';
    }
    moment.locale('pt-br');
    return moment(valor).format('DD/MM/YYYY HH:mm');
};
